import Community from "./Community.png";
import Apple from "./AppleIcon.png";
import PlayStore from "./PlayStore.png";
import Flow from "./Flow.png";
import Users from "./Users.png";
import Queries from "./Queries.png";
import Event from "./Event.png";
import Iphone from "./iPhone14.png";
import GreenDot from "./GreenDot.png";
import AppleBlack from "./AppleBlack.svg";
import PlayBlack from "./PlayBlack.png";
import Instagram from "./Instagram.png";
import Facebook from "./facebook.png";
import LinkedIn from "./linkedin.png";
import X from "./x.png";
import Youtube from "./youtube.png";
import Chat from "./Chat.png";
import User from "./User.png";
import EventBig from "./EentBig.png";
import EventSmall from "./EventSmall.png";
import groupProfileIcon from "./groupProfileIcon.png";
// import logo from './avasifyLogo.png'
import CommunityMember from "./CommunityMember.png";
// import Member2 from './Member2.png'
// import Left from './LeftChevron.svg'
// import Right from './Right.svg'
// import BackIcon from './BackIcon.svg'
// import Bag from './Bag.svg'
// import Bulb from './Bulb.svg'
// import Work from './work.svg'
// import Document from './Document.svg'
import Documents from "./Documents.svg";
import HomeIcon from "./HomeIcon.svg";
import Bell from "./Bell.svg";
import Profile from "./Profile.svg";
import Receipt from "./Receipt.svg";
import ReportIssue from "./ReportIssue.svg";
import People from "./People.svg";
import PropertySearch from "./PropertySearch.svg";
import Referral from "./Refferal.svg";
import Share from "./Share.svg";
import Wallet from "./Wallet.svg";
import Rupee from "./Rupee.svg";
import Rewards from "./Rewards.svg";
import Checkin from "./CheckIn.svg";
import Agreement from "./Agreement.svg";
import logo from "./logo.svg";
import jobUpload from "./Job.Upload.svg";
import DesignItem from "./DesignItem.png";

import fire from "./fire.png";

import frame17 from "./Career Screen/Frame 17.png";
import frame18 from "./Career Screen/Frame 18.png";
import frame19 from "./Career Screen/Frame 19.png";
import frame20 from "./Career Screen/Frame 20.png";
import line1 from "./Career Screen/Vector 171.png";
import line2 from "./Career Screen/Vector 170.png";
import FlowSmall from "./FlowSmall.svg";

// import CommunityMember from "./CommunityMember.png";
import Member2 from "./Member2.png";
import Left from "./LeftChevron.svg";
import Right from "./Right.svg";
import CareerImage from "./CareerImage.svg";
import BackIcon from "./BackIcon.svg";
import Bag from "./Bag.svg";
import Bulb from "./Bulb.svg";
import Work from "./work.svg";
import Document from "./Document.svg";
import HamburgerMenu from "./Hamburger menu.svg";
import crossIcon from "./corssIcon.svg";
import laptopImg from "./laptopImg.png";
import jobFormHeroImg from "./jobForm_HeroImage.svg";
import ImageSvg from "./CorporateScreen/ImageSvg.svg";
import LineVector from "./CorporateScreen/LineVector.png";
import Circle from "./CorporateScreen/Circle.png";
import leftArrow from "./CorporateScreen/leftArrow.png";
import rightArrow from "./CorporateScreen/rightArrow.png";
import phoneIcon from "./CorporateScreen/phoneIcon.png";
import locationIcon from "./CorporateScreen/locationIcon.png";
import emailIcon from "./CorporateScreen/emailIcon.png";
import CircleDesign from "./CorporateScreen/CircleDesign.png";
import blackApple from "./blackApple.svg";
import blackPlaystore from "./blackPlaystore.svg";
import uploadButton from "./uploadButton.png";
import phone from "./iPhone 14.png";
import circleArrow from "./Left arrow.svg";

export { groupProfileIcon, logo };
export const images = {
  PropertySearch,
  Wallet,
  Share,
  jobUpload,
  Referral,
  CareerImage,
  People,
  FlowSmall,
  Documents,
  HomeIcon,
  Bell,
  Checkin,
  Agreement,
  Rewards,
  Profile,
  Receipt,
  ReportIssue,
  Rupee,

  // logo,
  groupProfileIcon,
  Community,
  Apple,
  PlayStore,
  Flow,
  Users,
  Queries,
  User,
  Event,
  BackIcon,
  Bag,
  Bulb,
  Work,
  Document,

  Left,
  Right,
  CommunityMember,
  Member2,
  Iphone,
  PlayBlack,
  AppleBlack,
  GreenDot,
  Chat,
  Youtube,
  X,
  logo,
  LinkedIn,
  Instagram,
  Facebook,
  EventBig,
  EventSmall,
  DesignItem,
  fire,

  frame17,
  frame18,
  frame19,
  frame20,
  line1,
  line2,
  HamburgerMenu,
  crossIcon,
  laptopImg,
  jobFormHeroImg,
  ImageSvg,
  LineVector,
  Circle,
  leftArrow,
  rightArrow,
  phoneIcon,
  locationIcon,
  emailIcon,
  CircleDesign,
  uploadButton,
  blackApple,
  blackPlaystore,
  phone,
  circleArrow,
};
